import React, { useEffect, useState } from "react";
// import axios from "axios";
import { Controller } from "react-hook-form";
import {
  Autocomplete,
  CircularProgress,
  IconButton,
  InputAdornment,
  TextField
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';

// POST method implementation:
async function postData(url = '', data = {}) {
  // Default options are marked with *
  const response = await fetch(url, {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    // mode: 'no-cors', // no-cors, *cors, same-origin
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  // console.log('postData response', response);

  // const response = await axios.post(url, { data })
  //   .then(res => {
  //     console.log(res);
  //     console.log(res.data);
  //   })

  return response.json(); // parses JSON response into native JavaScript objects
}

const baseAPIURL = process.env.REACT_APP_API_URL;
const localAPIURL = process.env.REACT_APP_LOCAL_API_URL;
const APIEndpoint = '/Account/SearchAccount';

// console.log('APIURL', APIURL);

function CompanyLookup({
  name,
  control,
  label,
  placeholder
}) {
  // const [search, setSearch] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [searchValue, setSearchValue] = useState(null);
  const [inputValue, setInputValue] = useState(null);

  useEffect(() => {
    // console.log('search', inputValue);
    // console.log('APIEndpoint', APIEndpoint);
    // let optionsData = [];

    if (inputValue && inputValue !== '') {
      setIsLoading(true);
      // const apiData = {
      //   endpoint: APIEndpoint,
      //   searchData: {
      //     "Search": inputValue
      //   }
      // }
      const apiData = {
        "method": "POST",
        "baseURL": baseAPIURL,
        "endpoint": APIEndpoint,
        "apiData": {
          "Search": inputValue
        }
      }
      // const searchData = `{"Search": "${inputValue}"}`
      // const fullAPIURL = APIURL + APIQuery;
      // console.log('apiData', apiData);

      postData(localAPIURL, apiData)
        .then(data => {
          // console.log('response data', data); // JSON data parsed by `data.json()` call
          let optionsData = [];
          const accounts = data.accountDetail;
          if (accounts.length) {
            optionsData = accounts.filter((element, index) => index < 499)
            .map((option) => ({
                title: `${option.accountName} - ${option.address}`,
                value: option
            }));
            // optionsData = bingData;
          }
          optionsData.push({
            title: "My company is not listed",
            value: {
              otherCompany: inputValue
            }
          })
          // console.log('optionsData', optionsData);
          setOptions(optionsData);
          setIsLoading(false);
        })
        .catch((error) => {
          console.log('postData error', error);
          setOptions([]);
          setIsLoading(false);
        });
    }
    else {
      setOptions([]);
    }

    return () => {
      setOptions([]);
      setIsLoading(false);
    }
  }, [searchValue, inputValue]);

  function coClk() {
    document.getElementById("ccc").focus();
    const ke = new KeyboardEvent('keydown', {
      bubbles: true, cancelable: true, keyCode: 13
    });
    document.getElementById("ccc").dispatchEvent(ke);
  }

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <Autocomplete
          control={control}
          value={value}
          id={name}
          onChange={(event, newValue) => {
            if (typeof newValue === 'string') {
              setSearchValue({
                title: newValue,
              });
            } else if (newValue && newValue.inputValue) {
              // Create a new value from the user input
              setSearchValue({
                title: newValue.inputValue,
              });
            } else {
              setSearchValue(newValue);
            }
            onChange(newValue);
          }}
          filterOptions={(x) => x}
          onInputChange={(event, newInputValue) => {
            setInputValue(newInputValue);
          }}
          selectOnFocus
          //clearOnBlur
          handleHomeEndKeys
          id="ccc"
          // id="free-solo-with-text-demo"
          options={options}
          getOptionLabel={(option) => {
            // Value selected with enter, right from the input
            if (typeof option === 'string') {
              return option;
            }
            // Add "xxx" option created dynamically
            if (option.inputValue) {
              return option.inputValue;
            }
            // Regular option
            return option.title;
          }}
          renderOption={(props, option) => <li {...props}>{option.title}</li>}
          freeSolo
          renderInput={(params) => (
            <TextField
              {...params}
              control={control}
              label={label}
              // name={name}
              placeholder={placeholder}
              required
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {isLoading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : (
                      <InputAdornment position="end">
                        <IconButton onClick={coClk} id="cccb">
                          {/* <SearchIcon /> */}
                        </IconButton>
                      </InputAdornment>
                    )}
                    {params.InputProps.endAdornment}
                  </>
                )
              }}
            />
          )}
        />
      )}
    />
  );
};

export default CompanyLookup;
